import { BaseQueryParams } from "../../../../Common/QueryParamsHelper";

export class QueryParams extends BaseQueryParams
{
    public expandedNodeId?: number;

    public serialise(propertyName: keyof QueryParams, propertyValue: any): string | null
    {
        switch (propertyName)
        {
            case 'expandedNodeId':
                return this.serialiseNumber(propertyValue);
            default:
                return super.serialise(propertyName, propertyValue);
        }
    }

    public deserialise(propertyName: keyof QueryParams, queryValue: string | null): any
    {
        switch (propertyName)
        {
            case 'expandedNodeId':
                return this.deserialiseNumber(queryValue);
            default:
                return super.deserialise(propertyName, queryValue);
        }
    }
}
